import { echoAddress, defaultImg, avatarDefaultImg, userInfoHeaderHttp } from '@/config/config';
import { MessageBox } from 'element-ui';

function bindPic(el, binding) {
  const defaultPic = binding.modifiers.avatar ? avatarDefaultImg : defaultImg;
  const baseUrl = binding.modifiers.oauth ? userInfoHeaderHttp : echoAddress;
  if (!binding.value) {
    el.setAttribute('src', defaultPic);
    return;
  }
  const imgUrl = baseUrl + binding.value;
  let img = new Image();
  img.onload = function() {
    el.setAttribute('src', imgUrl);
    img = null; // 释放实例
  };
  img.onerror = function() {
    el.setAttribute('src', defaultPic);
    img = null;
  };
  img.src = imgUrl;
}
function messagePreview(el) {
  MessageBox.confirm(el.outerHTML, '', {
    center: true,
    showConfirmButton: false,
    showCancelButton: false,
    dangerouslyUseHTMLString: true,
    // showClose: false,
    customClass: 'directives-img-preview'
  }).catch(err => console.log(err));
}

/**
 * 全局指令
 */
const directives = {
  /**
   * 图片占位符，错误加载默认图片指令
   * 配置公共图片前缀，不必再次拼接
   */
  pic: {
    inserted: (el, binding) => {
      if (el.tagName === 'IMG') bindPic(el, binding);
    },
    update: (el, binding) => {
      if (el.tagName === 'IMG') bindPic(el, binding);
    }
  },
  preview: {
    inserted: el => {
      if (el.tagName === 'IMG') el.addEventListener('click', () => messagePreview(el));
    },
    unbind: el => {
      if (el.tagName === 'IMG') el.removeEventListener('click', () => messagePreview(el));
    }
  }
};

export default Vue => {
  Vue.directive('pic', directives.pic), Vue.directive('preview', directives.preview);
};
